<template>
    <div class="index-productService">
        <div class="index-productService-title" ref="serviceTitle" :class="{active:isActive}">
            <p class="index-productService-title-zh">{{$t('navBar.serve')}}</p>
            <p class="index-productService-title-en" v-show="$i18n.locale==='zh'">PRODUCT SERVICES</p>
        </div>
        <div class="index-productService-content" ref="serviceContent" :class="{active:isActive}">
            <div class="index-productService-content-productBox" v-for="(list,index) in serviceProductList"
                 @mouseenter="list.cloak=true"
                 @mouseleave="list.cloak=false"
                 @click="phoneClickShow(list)"
            >
                <div :class="{cloakShow:list.cloak}">{{$t(list.introduce)}}</div>
                <img :src="list.img" alt="">
                <transition name="productService">
                        <span class="cloak" v-show="list.cloak" ref="cloak">
                            <div class="ripple"></div>
                        </span>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>

    import {isPC} from "../../utils/methods";

    export default {
        name: "productService",
        data() {
            return {
                serviceProductList: [
                    {introduce: 'productService.app', img: require('../../assets/移动App定制iOSAndroid.png'), cloak: false},
                    {introduce: 'productService.hardware', img: require('../../assets/硬件改造建设.png'), cloak: false},
                    {introduce: 'productService.weiXin', img: require('../../assets/微信公众号小程序开发.png'), cloak: false},
                    {introduce: 'productService.website', img: require('../../assets/网站系统定制.png'), cloak: false},
                    {introduce: 'productService.operate', img: require('../../assets/运营推广服务.png'), cloak: false},
                    {introduce: 'productService.company', img: require('../../assets/政府企事业单位信息化建设.png'), cloak: false},
                ],
                isActive: false,
                name:'product'
            }
        },
        methods: {
            // rippleShow(e, index) {
            //     let [trigger, wrapper] = [e.target.children[0] || e.target, this.$refs.cloak[index]]
            //     trigger.classList.remove('animate')
            //     let x = parseInt(e.pageX - wrapper.getBoundingClientRect().left);
            //     let y = parseInt(e.pageY - wrapper.getBoundingClientRect().top - document.documentElement.scrollTop);
            //     trigger.style.top = y + 'px'
            //     trigger.style.left = x + 'px'
            //     trigger.classList.add('animate')
            // }
            phoneClickShow(list){
                if(isPC())return
                this.serviceProductList.forEach(list=>list.cloak = false)
                list.cloak =!list.cloak
            }
        },
        mounted() {
                if (this.$route.fullPath === '/#product'&&!this.isActive) {
                    setTimeout(() => {
                        this.isActive = true
                    }, 200)
                }
        },
        watch:{
           '$route.fullPath'(){
               if (this.$route.fullPath === '/#product'&&!this.isActive) {
                   setTimeout(() => {
                       this.isActive = true
                   }, 200)
               }
           }
        }
    }
</script>

<style scoped lang="scss" src="./productservice.scss"></style>
